<template>
	<div class="userlogin">
		<div class="text_box">
			<div class="title">
				手机号密码登录
			</div>
			<div class="text">
				未注册的用户验证后将自动注册并登录
			</div>
		</div>
		<div class="userlogin_box">
			<div class="input_box">
				<input class="my_input" placeholder="请输入手机号" type="tel" maxlength="11" v-model="info.phone"
					@input="telInput" ref="phoneInput" :focus="isFocused">
				<div class="input_Box_closeA" v-if="showClearIcon" @click.stop.prevent="clearIcon">
					<img src="@/assets/image/icon/loginClose.png" alt="">
				</div>
			</div>
			<div class="input_box" style="margin-top: 1.5rem;">
				<input maxlength="20" :type="passwordShow ? 'text' : 'password'" v-model="info.password"
					@input="e => passwordinput(e, 'password')" placeholder="请输入密码" class="my_input" />
				<div class="input_Box_close" v-if="info.password.length > 0"
					@click.stop.prevent="passwordShow = !passwordShow">
					<img :class="passwordShow ? 'image_show' : 'image_hide'"
						:src="passwordShow ? require('@/assets/image/set/password1.png') : require('@/assets/image/set/password2.png')"
						alt="">
				</div>
			</div>
			<div class="forget" @click.stop="$emit('onceRegister', 3)">忘记密码？</div>
			<single-button v-if="show" @know="register" text="登录"
				background="linear-gradient(90deg, #1D1D1D 0%, #5B4E3F 100%)" width="15rem" height="2.5rem"
				color="#FFDB89" fontSize="0.8rem" />
			<single-button v-else background="#8E8E8E" text="登录" width="15rem" height="2.5rem" color="#fff"
				fontSize="0.8rem" />
		</div>
	</div>
</template>

<script>
import { loginWithUsername } from "@/api/auth.js"
import { LETTER_NUMBER, LETTER_NUMBER_PASSWORD } from "@/utils/constants.js"

export default {
	name: 'UserLogin',

	props: {
		isInputFocus: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			show: false,
			info: {
				password: "",
				phone: "",
			},
			min: 6,
			max: 11,
			passwordShow: false,
			showClearIcon: false,
			isFocused: false,
			buttonStyle: {
				width: '15rem',
				height: '2.5rem',
				background: 'linear-gradient(90deg, #1D1D1D 0%, #5B4E3F 100%)',
				color: '#FFDB89',
				fontSize: '0.8rem'
			},
			disabledButtonStyle: {
				width: '15rem',
				height: '2.5rem',
				background: '#8E8E8E',
				color: '#fff',
				fontSize: '0.8rem'
			}
		}
	},
	mounted() {
		if (this.isInputFocus) {
			this.onFocus()
		}
		const savedPhone = localStorage.getItem('loginPhoneNumber')
		if (savedPhone) {
			this.info.phone = savedPhone
			this.showClearIcon = this.info.phone.length > 0
		}
	},
	watch: {
		info: {
			handler(val) {
				this.show = val.phone.length === this.max && val.password.length >= this.min
				if (!val.password) {
					this.passwordShow = false
				}
			},
			deep: true
		}
	},
	methods: {
		onFocus() {
			this.isFocused = true
		},
		clearIcon() {
			this.info.phone = ""
			this.showClearIcon = false
			localStorage.removeItem('loginPhoneNumber')
		},
		telInput(e) {
			const length = e.target.value.length
			this.info.phone = e.target.value.replace(/[^\d]/g, '')
			this.showClearIcon = length > 0
			localStorage.setItem('loginPhoneNumber', e.target.value)
		},
		passwordinput(e, name) {
			this.$nextTick(() => {
				let value = e.target.value
				value = value.replace(/[^a-zA-Z0-9]/g, '')
				this.info[name] = value
			})
		},
		register() {

			const regex = /^1[3456789]\d{9}$/
			if (!regex.test(this.info.phone)) {
				this.info.phone = ''
				this.$toast('请输入正确的手机号')
				return
			}
			if (!LETTER_NUMBER_PASSWORD.test(this.info.password)) {
				this.info.password = ""
				this.$toast("密码不存在，请重新输入")
				return
			}
			console.log(52222222);
			this.$emit("send", this.info)
		}
	}
}
</script>

<style lang="scss" scoped>
.userlogin {
	.text_box {
		font-size: 0.6rem;
		color: #CACACA;
		padding-bottom: 1.35rem;

		.title {
			font-weight: bold;
			font-size: 0.8rem;
			color: #1D1D1D;
			padding-bottom: 0.3rem;
		}
	}

	.userlogin_box {
		width: 15rem;
		margin: 0 auto;

		.input_box {
			width: 100%;
			border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			color: #1D1D1D;
			padding-bottom: 0.5rem;

			.my_input {
				width: 8.5rem;
				color: #1D1D1D;
				font-size: 0.8rem;
				flex: 1;
				border: unset;

				&::placeholder {
					color: #8E8E8E;
				}
			}

			.input_Box_close,
			.input_Box_closeA {
				width: 2.5rem;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				padding-right: 0.25rem;

				img {
					display: block;
					width: 0.6rem;
					height: 0.6rem;
				}
			}
		}

		.forget {
			text-align: end;
			color: #855200;
			font-size: 0.7rem;
			margin-top: 0.55rem;
			margin-bottom: 1.4rem;
			cursor: pointer;
		}
	}
}
</style>